export const FEATURE_FLAGS = {
  ENABLE_ACTIVITY_LOG: 'enable_activity_log',
  ENABLE_NEW_SETTINGS_MENU_ITEMS: 'enable_new_settings_menu_items',
  ENABLE_MODIFICATION_REQUESTS_DRAWER: 'enable_modification_requests_drawer',
  ENABLE_ACTIVITY_CARD_DRAWER: 'enable_activity_card_drawer',
  ENABLE_NEW_PDF_EXPORTING_MODAL: 'enable_new_pdf_exporting_modal',
  ENABLE_BULK_ACTIONS_BAR: 'enable_bulk_actions_bar'
};
